export const WORK_YEARS_OPTIONS = [
  '应届生（<1年）',
  '初级（1～2年）',
  '中级（3～5年）',
  '高级（6～10年）',
  '资深（10年以上）',
];

export const INDUSTRIES_OPTIONS = [
  '互联网',
  '金融',
  '房地产/建筑/物业',
  '消费品/零售/贸易',
  '广告/传媒',
  '生产制造',
];

export const ORGS_OPTIONS = ['辩论队', '学生会', '文艺汇演', '研究室', '校园公众号', '学生社团'];

export const HONOR_OPTIONS = [
  "国家奖学金",
  "国家级运动员",
  "优秀学生",
  "大学生创业大赛",
  "优秀毕业生",
  "优秀志愿者"
];

export const STUDENT_SKILLS_OPTIONS = [
  "责任感强",
  "独立自主",
  "积极主动",
  "善于沟通",
  "勤奋学习",
  "成熟稳重",
  "创意丰富",
  "团队协作",
  "细心耐心"
];

export const SKILLS_OPTIONS = [
  '沟通协作',
  '项目管理',
  '应急预案',
  '领导力',
  '冲突解决',
  '自我驱动',
  '创新思维',
  '适应能力',
  '自我审视',
];

export const CERTIFICATE_OPTIONS = [
  '英语四级CET-4',
  '英语六级CET-6',
  '计算机等级考试',
  '普通话水平测试',
  '机动车驾驶证',
  '证券从业资格证',
];

export const RESUME_OPTIONS = [
  { text: '已有简历', value: 'yes' },
  { text: '没有简历', value: 'no' },
];

export const LOCAL_STEPS = ['init', 'import', 'progress'];
export const BASED_STEPS = ['init', 'resume'];
export const AI_STEPS_STUDENT = [
  'init',
  'university',
  'profession',
  'organization',
  'skills',
  'certificate',
  'honor',
  'profile',
];
export const AI_STEPS_WORKER = [
  'init',
  'experience',
  'profession',
  'industry',
  'university',
  'skills',
  'certificate',
  'profile',
];
export const TEMPLATE_STEPS = ['init'];

export const EDU_TYPES = {
  cn: [
    {
      label: '全日制',
      value: '全日制',
    },
    {
      label: '非全日制',
      value: '非全日制',
    },
    {
      label: '交换/交流',
      value: '交换/交流',
    },
  ],
  en: [
    {
      label: 'Full Time',
      value: 'Full-time',
    },
    {
      label: 'Part Time',
      value: 'Part-time',
    },
    {
      label: 'Exchange',
      value: 'Exchange',
    },
  ],
};
